if (!window.Eurus.loadedScript.has('pagination.js')) {
  window.Eurus.loadedScript.add('pagination.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xPagination", (sectionId) => ({
        loading: false,
        loadData(url) {
          this.loading = true
          fetch(url)
          .then(response => response.text())
          .then(response => {
            const parser = new DOMParser();
            const html = parser.parseFromString(response,'text/html');
            const productGrid = html.getElementById('items-grid');
            const newProducts = productGrid.getElementsByClassName('grid-item');
            let productsOnPage = document.getElementById("items-grid");
            let blogGrid = document.getElementById("blog-grid");
            if (blogGrid) { productsOnPage = blogGrid }
            for (let i = 0; i < newProducts.length; i++) {
              setTimeout(() => {
                productsOnPage.insertAdjacentHTML('beforeend', newProducts[i].innerHTML);
                if (i === newProducts.length - 1) {
                  this._renderButton(html);
                }
              }, i*300);
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            this.loading = false;
          })
        },
        loadAllData(url) {
          this.loading = true;
          const loadPage = (pageUrl) => {
            return fetch(pageUrl)
              .then(response => response.text())
              .then(response => {
                const parser = new DOMParser();
                const html = parser.parseFromString(response, 'text/html');

                const productGrid = html.getElementById('items-grid');
                if (!productGrid) return null;

                const newProducts = productGrid.getElementsByClassName('grid-item');

                let productsOnPage = document.getElementById('items-grid');
                const blogGrid = document.getElementById('blog-grid');
                if (blogGrid) productsOnPage = blogGrid;

                for (let i = 0; i < newProducts.length; i++) {
                  productsOnPage.insertAdjacentHTML(
                    'beforeend',
                    newProducts[i].innerHTML
                  );
                }

                const nextLink = html.querySelector('[rel="next"]');
                return nextLink ? nextLink.getAttribute('href') : null;
              });
          };

          const loadRecursive = (nextUrl) => {
            if (!nextUrl) return Promise.resolve();

            return loadPage(nextUrl).then(newNextUrl => {
              return loadRecursive(newNextUrl);
            });
          };

          loadRecursive(url)
            .catch(e => console.error(e))
            .finally(() => {
              this._disableButton();
              this.loading = false;
            });
        },
        _renderButton(html) {
          const destination = document.getElementById('btn-pagination-' + sectionId);
          const source = html.getElementById('btn-pagination-' + sectionId);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
          }
        },
        _disableButton() {
          const destination = document.getElementById('btn-pagination-' + sectionId);
          if (destination) {
            destination.style.display = "none";
          }
        }
      }));
    });
  });
}